import SkeletonLoader from "react-loading-skeleton";

import { skeletonCss, skeletonWrapperCss } from "./Skeleton.style";

const Skeleton = (props) => {
  return (
    <div css={skeletonWrapperCss}>
      <SkeletonLoader css={skeletonCss} {...props} />
    </div>
  );
};

export default Skeleton;
